<template>
    <div class="maintenance" v-if="isActive">
        <div class="maintenance__inner">
            <h1>Wartungsarbeiten</h1>
        </div>
    </div>
</template>

<script>
import { getEnvironment } from '@/helpers/utils';

export default {
    data() {
        return {
            isActive: this.active,
            count: 0
        };
    },
    methods: {
        keypressListener(e) {
            if (e.key === 'p') {
                this.count++;
            }
            if (this.count > 5) {
                this.isActive = false;
                document.removeEventListener('keypress', this.keypressListener);
            }
        }
    },
    mounted() {
        if (getEnvironment() === 'development') {
            this.isActive = false;
        }
        document.addEventListener('keypress', this.keypressListener);
    },
    props: {
        active: Boolean
    }
};
</script>
